.feedback {
  border: 1px solid;
  border-radius: var(--rounded-default);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  div.item {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    header {
      display: flex;
      flex-direction: row;
      align-items: flex-start;

      svg {
        flex: 0 0 1.5rem;
        width: 1.5rem;
        margin-right: 0.5rem;
      }

      h3 {
        margin-bottom: 0;
        flex: 1 1 auto;
      }

      span {
        flex: 0 0 auto;
        font-weight: bold;
        padding-left: 1.5rem;
      }
    }

    div.content {
      max-width: 40rem;
      a:visited {
        color: var(--interactive-default);
      }
    }
  }

  div.actions {
    max-width: 40rem;
    ul {
      margin: 0;
    }
  }

  &.error {
    border-color: var(--color-error-darker);
    background-color: var(--color-error-bg);
    svg {
      fill: var(--color-error-darker);
    }
  }
  &.warning {
    border-color: var(--color-warning);
    background-color: var(--color-warning-bg);
    svg {
      fill: var(--color-warning);
    }
  }
  &.notify {
    border-color: var(--color-notify);
    background-color: var(--color-notify-bg);
    svg {
      fill: var(--color-notify);
    }
  }
  &.success {
    border-color: var(--color-success);
    background-color: var(--color-success-bg);
    svg {
      fill: var(--color-success);
    }
  }
}
